import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { LIMIT_ORDER_STATUS_LABEL_MAP } from '@root/entities/limit-order/ui/constants'
import { useTranslation } from '@root/shared/localization'

import { orderStatusAtom } from '../../../atoms/trading-orders'

import type { LimitOrder } from '@root/entities/limit-order'

type Props = {}

const statuses = Object.keys(
  LIMIT_ORDER_STATUS_LABEL_MAP,
) as Array<LimitOrder.Status>

export const OrdersExpandedContentFilter: React.FC<Props> = () => {
  const { t } = useTranslation()

  const [activeStatus, setActiveStatus] = useAtom(orderStatusAtom)

  return (
    <Root>
      <Tabs>
        {statuses.map((status) => (
          <StatusButton
            type="button"
            key={status}
            $active={activeStatus === status}
            onClick={() => setActiveStatus(status)}
          >
            {t(LIMIT_ORDER_STATUS_LABEL_MAP[status])}
          </StatusButton>
        ))}
      </Tabs>
    </Root>
  )
}

const Root = styled.div`
  display: grid;

  gap: 14px;
  margin-inline: 14px;
`

const Tabs = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 4px;
`

const StatusButton = styled.button<{ $active?: boolean }>`
  cursor: pointer;
  color: ${({ $active }) => ($active ? 'var(--text-12)' : 'var(--text-10)')};
  background: ${({ $active }) =>
    $active ? 'var(--backgroundA-4)' : 'var(--background-2)'};

  border: 1px solid rgba(255 255 255 / 3%);

  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  gap: 10px;
  border-radius: 10px;

  font-size: var(--typography-body-4-semi-bold-font-size);
  line-height: var(--typography-body-4-semi-bold-line-height);
  font-weight: var(--typography-body-4-semi-bold-font-weight);
`
